import { render } from "./AppSlider.vue?vue&type=template&id=f5126122&scoped=true"
import script from "./AppSlider.vue?vue&type=script&lang=js"
export * from "./AppSlider.vue?vue&type=script&lang=js"

import "./AppSlider.vue?vue&type=style&index=0&id=f5126122&scoped=true&lang=css"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5126122"]])

export default __exports__